import { request } from '_apiPublic/client'

export const getPaymentCardInfo = async (premiseId, params) => {
    return await request('GET', `payment/payment_url/${premiseId}/`, params)
}
